import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VehicleAdapter } from './dto/vehicle.adapter';
import { VehicleMasterController } from './vehicle-master.controller';
import { VehicleMaster } from './vehicle-master.entity';
import { VehicleMasterService } from './vehicle-master.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([VehicleMaster]),
  ],
  controllers: [VehicleMasterController],
  providers: [VehicleMasterService,VehicleAdapter,ApplicationExceptionHandler,LogsService]
})
export class VehicleMasterModule {}
